/* eslint-disable import/no-unresolved */
import React from 'react';
import { Row } from 'antd';
// import { Aside, Content } from './overview/style';

const AuthLayout = WraperContent => {
  return () => {
    return (
      <Row justify="center" align="center">
        {/* <Col xxl={10} xl={10} lg={12} md={8} xs={24}>
          <Aside>
            <div className="auth-side-content">
              <Content>
                <img style={{ width: '130px' }} src={require('../../../static/img/Liqural-Logo.png')} alt="" />
                <br />
                <br />
                <h1 style={{ color: '#4285F4', fontSize: '18px', fontWeight: '700' }}>
                  ARTIFICIAL INTELLIGENCE POWERED <br />
                  MARKET ADVISORY SERVICE
                </h1>
                <img
                  className="auth-content-figure"
                  src={require('../../../static/img/auth-aside.png')}
                  style={{ marginTop: '20px' }}
                  alt=""
                />
              </Content>
            </div>
          </Aside>
        </Col> */}

        {/* <Col xxl={14} xl={14} lg={12} md={16} xs={24}>
          <WraperContent />
        </Col> */}
        <div style={{ width: 'auto', padding: '20px' }}>
          <WraperContent />
        </div>
      </Row>
    );
  };
};

export default AuthLayout;

//   background-image: url("${require('../../../../static/img/auth/BG.png')}");
